<template>
    <Loader v-if="loading" />
    <div style="padding: 1rem;">

        <div class="space-y-2">
            <h2 class="text-lg font-semibold text-center">Seleziona fornitura</h2>
            <SelectButton v-model="tipo" :options="['ee', 'gas']" class="m-2" />
        </div>

        <div class="flex flex-column md:flex-row md:align-items-start gap-3 mb-3">
            <!-- Contenitore input -->
            <div class="flex flex-column gap-2 w-full">
                <!-- Input: nome file -->
                <span class="p-input-icon-left w-full">
                    <i class="pi pi-search" />
                    <InputText v-model="searchFile" placeholder="Cerca per nome file" class="w-full" />
                </span>

                <!-- Input: POD -->
                <span class="p-input-icon-left w-full mt-2">
                    <i class="pi pi-search" />
                    <InputText v-model="searchPod" placeholder="Cerca per Fornitura (14 caratteri)" class="w-full" />
                </span>
                
                <!-- Bottone cerca -->
                <div class="pt-2" >
                    <Button label="Cerca" icon="pi pi-search" @click="onSearch"/>
                </div>
            </div>
        </div>

        <Card>
            <template #title>Flussi {{ tipoLabel }}</template>
            <template #content>
                <div v-if="logs?.length">
                    <DataTable :value="logs" lazy :paginator="true" :rows="rows" :totalRecords="totalRecords"
                        :first="(currentPage - 1) * rows" @page="onPage" @sort="onSort" stripedRows
                        responsiveLayout="scroll" class="lv-data-table">
                        <Column field="id" header="ID" sortable />
                        <Column field="file" header="Nome File" sortable />
                        <Column field="quanti" header="Letture" sortable />
                        <Column field="creation_time" header="Data" sortable />
                        <Column header="Azioni" style="min-width: 30rem">
                            <template #body="slotProps">
                                <button
                                    @click="viewDownloadXmlFile(slotProps.data.id, slotProps.data.creation_time, 'download')"
                                    class="p-button p-button-text" :disabled="downloading">
                                    <i v-if="downloading" class="pi pi-spinner pi-spin mr-1" style="color: black"></i>
                                    <i v-else class="pi pi-download mr-1" style="color: black"></i>
                                    Download XML
                                </button>

                                <button 
                                    @click="viewDownloadXmlFile(slotProps.data.id, slotProps.data.creation_time, 'view')"
                                    class="p-button p-button-text">
                                    <i class="pi pi-file mr-1" style="color:black"></i> Vedi File
                                </button>
                                <button @click="viewDetails(slotProps.data.id, slotProps.data.file)"
                                    class="p-button p-button-text">
                                    <i class="pi pi-eye mr-1" style="color:black"></i> Vedi Dettagli
                                </button>
                            </template>
                        </Column>
                    </DataTable>
                </div>
                <div v-else>Caricamento log...</div>
            </template>
        </Card>

        <Dialog v-model:visible="dialogVisible" modal :header="fileSelezionato || 'Dettagli File'"
            :style="{ width: '95vw', maxHeight: '80vh'}" :draggable="false">
            <div class="dialog-content">
                <div v-if="fileDettagli.length">

                    <DataTable v-if="tipo === 'ee'" :value="fileDettagli" stripedRows scrollable scrollHeight="75vh"
                        :scrollDirection="'both'" class="lv-data-table">
                        <Column field="pod" header="POD" :style="{ width: '150px', minWidth: '150px' }"
                            :headerStyle="{ width: '155px', minWidth: '150px' }" />

                        <Column field="data_misura" header="Data Misura" :style="{ width: '120px', minWidth: '120px' }"
                            :headerStyle="{ width: '125px', minWidth: '120px' }" />

                        <Column field="eaf1" header="EAF1" :style="{ width: '100px', minWidth: '100px' }"
                            :headerStyle="{ width: '105px', minWidth: '100px' }">
                            <template #body="slotProps">{{ formatNumber(slotProps.data.eaf1) }}</template>
                        </Column>
                        <Column field="eaf2" header="EAF2" :style="{ width: '100px', minWidth: '100px' }"
                            :headerStyle="{ width: '105px', minWidth: '100px' }">
                            <template #body="slotProps">{{ formatNumber(slotProps.data.eaf2) }}</template>
                        </Column>
                        <Column field="eaf3" header="EAF3" :style="{ width: '100px', minWidth: '100px' }"
                            :headerStyle="{ width: '105px', minWidth: '100px' }">
                            <template #body="slotProps">{{ formatNumber(slotProps.data.eaf3) }}</template>
                        </Column>

                        <Column field="erf1" header="ERF1" :style="{ width: '100px', minWidth: '100px' }"
                            :headerStyle="{ width: '105px', minWidth: '100px' }">
                            <template #body="slotProps">{{ formatNumber(slotProps.data.erf1) }}</template>
                        </Column>
                        <Column field="erf2" header="ERF2" :style="{ width: '100px', minWidth: '100px' }"
                            :headerStyle="{ width: '105px', minWidth: '100px' }">
                            <template #body="slotProps">{{ formatNumber(slotProps.data.erf2) }}</template>
                        </Column>
                        <Column field="erf3" header="ERF3" :style="{ width: '100px', minWidth: '100px' }"
                            :headerStyle="{ width: '105px', minWidth: '100px' }">
                            <template #body="slotProps">{{ formatNumber(slotProps.data.erf3) }}</template>
                        </Column>

                        <Column field="erif1" header="ERIF1" :style="{ width: '100px', minWidth: '100px' }"
                            :headerStyle="{ width: '105px', minWidth: '100px' }">
                            <template #body="slotProps">{{ formatNumber(slotProps.data.erif1) }}</template>
                        </Column>
                        <Column field="erif2" header="ERIF2" :style="{ width: '100px', minWidth: '100px' }"
                            :headerStyle="{ width: '105px', minWidth: '100px' }">
                            <template #body="slotProps">{{ formatNumber(slotProps.data.erif2) }}</template>
                        </Column>
                        <Column field="erif3" header="ERIF3" :style="{ width: '100px', minWidth: '100px' }"
                            :headerStyle="{ width: '105px', minWidth: '100px' }">
                            <template #body="slotProps">{{ formatNumber(slotProps.data.erif3) }}</template>
                        </Column>

                        <Column field="pf1" header="PF1" :style="{ width: '100px', minWidth: '100px' }"
                            :headerStyle="{ width: '105px', minWidth: '100px' }">
                            <template #body="slotProps">{{ formatNumber(slotProps.data.pf1) }}</template>
                        </Column>
                        <Column field="pf2" header="PF2" :style="{ width: '100px', minWidth: '100px' }"
                            :headerStyle="{ width: '105px', minWidth: '100px' }">
                            <template #body="slotProps">{{ formatNumber(slotProps.data.pf2) }}</template>
                        </Column>
                        <Column field="pf3" header="PF3" :style="{ width: '100px', minWidth: '100px' }"
                            :headerStyle="{ width: '105px', minWidth: '100px' }">
                            <template #body="slotProps">{{ formatNumber(slotProps.data.pf3) }}</template>
                        </Column>

                        <Column field="validato" header="Validato" :style="{ width: '100px', minWidth: '100px' }"
                            :headerStyle="{ width: '105px', minWidth: '100px' }" />

                        <Column field="type" header="Tipo" :style="{ width: '100px', minWidth: '100px' }"
                            :headerStyle="{ width: '105px', minWidth: '100px' }" />
                    </DataTable>

                    <DataTable v-if="tipo === 'gas'" :value="fileDettagli" stripedRows scrollable scrollHeight="75vh"
                        :scrollDirection="'both'" class="lv-data-table">
                        <Column field="pdr" header="PDR" :style="{ width: '200px', minWidth: '200px' }"
                            :headerStyle="{ width: '205px', minWidth: '205px' }" />

                        <Column field="data_misura" header="Data Misura" :style="{ width: '150px', minWidth: '150px' }"
                            :headerStyle="{ width: '155px', minWidth: '155px' }" />

                        <Column field="consumo" header="Consumo" :style="{ width: '125px', minWidth: '125px' }"
                            :headerStyle="{ width: '130px', minWidth: '130px' }">
                            <template #body="slotProps">{{ formatNumber(slotProps.data.consumo) }}</template>
                        </Column>
                        <Column field="coeff" header="Coefficiente" :style="{ width: '125px', minWidth: '125px' }"
                            :headerStyle="{ width: '130px', minWidth: '130px' }">
                            <template #body="slotProps">{{ formatNumber(slotProps.data.coeff) }}</template>
                        </Column>

                        <Column field="type" header="Tipo" :style="{ width: '125px', minWidth: '125px' }"
                            :headerStyle="{ width: '130px', minWidth: '130px' }" />

                        <Column field="progressivo" header="Progressivo" :style="{ width: '125px', minWidth: '125px' }"
                            :headerStyle="{ width: '130px', minWidth: '130px' }" />

                        <Column field="tipolettura" header="Tipo Lettura" :style="{ width: '125px', minWidth: '125px' }"
                            :headerStyle="{ width: '130px', minWidth: '130px' }" />
                    </DataTable>
                </div>
                <div v-else>
                    <p>Nessun dettaglio disponibile.</p>
                </div>
            </div>
        </Dialog>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, getCurrentInstance, watch } from 'vue'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Card from 'primevue/card'
import SelectButton from 'primevue/selectbutton'
import LettureService from "../../../services/ask-letture/letture-service.js"
import Loader from "@/components/Loader.vue"

const tipo = ref('ee')
const logs = ref([])
const totalRecords = ref(0)
const currentPage = ref(1)
const rows = 50
const sortField = ref(null)
const sortOrder = ref(null)
const loading = ref(false)
const downloading = ref(false)

const searchFile = ref('');
const searchPod = ref('');

const fileSelezionato = ref('')
const dialogVisible = ref(false)
const fileDettagli = ref({})

const tipoLabel = computed(() => tipo.value.toUpperCase())

const instance = getCurrentInstance()
const eventBus = instance.appContext.config.globalProperties.$eventBus
const service = new LettureService(eventBus)

const fetchLogs = async (page = 1, sortFieldValue = null, sortOrderValue = null) => {
    loading.value = true

    const method = (tipo.value === 'ee'
        ? service.getFileLettureEELogs
        : service.getFileLettureGasLogs
    ).bind(service)

    const response = await method(page, rows, sortFieldValue, sortOrderValue)
    logs.value = response?.data ?? []
    totalRecords.value = response?.total ?? 0
    currentPage.value = response?.current_page ?? 1

    loading.value = false
}

const onPage = (event) => {
    const newPage = Math.floor(event.first / event.rows) + 1
    fetchLogs(newPage, sortField.value, sortOrder.value)
}

const onSort = (event) => {
    sortField.value = event.sortField
    sortOrder.value = event.sortOrder
    fetchLogs(currentPage.value, sortField.value, sortOrder.value)
}

const downloadFlussoXml = async (fileId, fileName, data = '') => {
    downloading.value = true
    await service.downloadXmlFile(fileId, fileName, tipo.value, data)
    downloading.value = false
}

const vediFile = async (fileId, data = '') => {
    service.viewXmlFile(fileId, tipo.value, data);
}

const viewDownloadXmlFile = async (fileId, data = '', mode) => {
    service.viewDownloadXmlFileFromGoogleBucket(fileId, tipo.value, data, mode);
}

const viewDetails = async (fileId, file) => {
    fileSelezionato.value = file
    
    const dettagli = await service.dettagliXmlFile(fileId, tipo.value);

    if (dettagli) {
        dialogVisible.value = true
        fileDettagli.value = dettagli
    } else {
        console.warn('Errore dettagli');
        alert('Errore');
    }
}

const formatNumber = (value) => {
  if (typeof value === 'number') {
    return value.toFixed(2)
  }
  if (!isNaN(value)) {
    return parseFloat(value).toFixed(2)
  }
  return value
}

watch(searchFile, (newValue) => {
    if (newValue) searchPod.value = ''
})

watch(searchPod, (newValue) => {
    if (newValue) searchFile.value = ''
})

const onSearch = async () => {

    if (searchPod.value === '' && searchFile.value === '') {
        alert('Campi vuoti');
        return;
    }

    let tipoRicerca = searchPod.value === '' ? 'flusso' : 'fornitura';
    let valoreRicerca = searchPod.value === '' ? searchFile.value : searchPod.value;
    
    if (tipoRicerca === 'fornitura' && searchPod.value.length != 14) {
        alert("La fornitura deve avere almeno 14 caratteri")
        return;
    }

    loading.value = true;

    const ris = await service.searchFiles(tipoRicerca, valoreRicerca, tipo.value);
    logs.value = ris ?? [];
    totalRecords.value = 0

    loading.value = false;
}

watch(tipo, () => {
    currentPage.value = 1
    fetchLogs(1, null, null)

    searchFile.value = '';
    searchPod.value = '';
})

onMounted(() => fetchLogs())
</script>

<style scoped>

    :deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th) {
    background: #495057 !important;
    color: #fff !important;
    border: none !important;
    padding: 1rem !important;
    font-weight: 600 !important;
    text-align: center !important;
    vertical-align: middle !important;
    font-family: 'Montserrat', sans-serif !important;
    }

    :deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th:hover) {
    background: #30656e !important;
    color: #fff !important;
    box-shadow: none !important;
    }

    :deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th.p-sortable-column:hover) {
    background: #30656e !important;
    color: #fff !important;
    box-shadow: none !important;
    }

    :deep(.lv-data-table.p-datatable .p-datatable-tbody > tr > td) {
    padding: 0.8rem 1rem !important;
    border-bottom: 1px solid #dee2e6 !important;
    font-size: 0.9rem !important;
    text-align: center !important;
    vertical-align: middle !important;
    font-family: 'Montserrat', sans-serif !important;
    }

    :deep(.lv-data-table.p-datatable .p-datatable-tbody > tr > td:first-child) {
    text-align: left !important;
    padding-left: 1.2rem !important;
    font-weight: 500 !important;
    }

    :deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th:first-child) {
    text-align: left !important;
    padding-left: 1.2rem !important;
    }

    :deep(.lv-data-table.p-datatable .p-datatable-tbody > tr:nth-child(even)) {
    background: #f8f9fa !important;
    }

    :deep(.lv-data-table.p-datatable .p-datatable-tbody > tr:hover) {
    background: #e9ecef !important;
    }

    :deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th .p-sortable-column-icon) {
    color: #fff !important;
    margin-left: 0.5rem !important;
    opacity: 1 !important;
    font-size: 0.9rem !important;
    display: inline-block !important;
    visibility: visible !important;
    }

    :deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th:hover .p-sortable-column-icon),
    :deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th.p-sortable-column:hover .p-sortable-column-icon) {
    color: #fff !important;
    opacity: 1 !important;
    visibility: visible !important;
    }

    :deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th.p-sortable-column) {
    cursor: pointer !important;
    user-select: none !important;
    }

    :deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th.p-sortable-column .p-column-header-content) {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    }

    :deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th:first-child.p-sortable-column .p-column-header-content) {
    justify-content: flex-start !important;
    }

    :deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th .p-column-title) {
    color: #fff !important;
    font-weight: 600 !important;
    }

    :deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th:not(.p-sortable-column):hover),
    :deep(.lv-data-table.p-datatable .p-datatable-thead > tr > th.p-sortable-column:not(:hover)) {
    background: #495057 !important;
    color: #fff !important;
    }

</style>